import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import classNames from "classnames";
import { useStyles } from "./styles";

const ButtonComponent = forwardRef(
  (
    {
      children,
      onClick,
      className,
      disabled = false,
      type = "button",
      title,
      bgColor,
      color,
      width,
      style,
      peNone,
      theme,
      loading,
      variant = "dark",
      isIcon,
      ...rest
    },
    ref
  ) => {
    const classes = useStyles({ theme });

    return (
      <Button
        title={title}
        type={type}
        ref={ref}
        className={classNames(classes.btn, className)}
        onClick={onClick}
        disabled={disabled}
        variant={variant}
        style={{ width, ...style }}
        {...rest}
      >
        {isIcon && isIcon}
        {loading ? "Loading..." : children}
      </Button>
    );
  }
);

ButtonComponent.propTypes = {
  theme: PropTypes.object,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.string,
  style: PropTypes.object,
  loading: PropTypes.bool,
  variant: PropTypes.string,
};

ButtonComponent.defaultProps = {
  onClick: () => {},
  className: "",
  disabled: false,
  width: "200px",
  style: {},
  loading: false,
  variant: "dark",
};

export default ButtonComponent;
